import { Component, ViewChild } from '@angular/core';
import { OverviewComponent } from '../overview/overview.component';
import { SideBarComponent } from '../side-bar/side-bar.component';
import { WelcomeBarComponent } from '../welcome-bar/welcome-bar.component';
import { HttpClient } from '@angular/common/http';
import { api } from '../URL/api-url';
import Swal from 'sweetalert2';
import { BehaviorSubject } from 'rxjs';
import { HeaderComponent } from '../header/header.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  width = "265px";
  displaySideBar = true;
  sidebarOpen = false;
  lang: any;
  formConfig: any;
  customer: any = [];
  customerSubject = new BehaviorSubject<any>(null);
  form_typess: any = [];

  @ViewChild(OverviewComponent) overview!: OverviewComponent;
  @ViewChild(SideBarComponent) sidebar!: SideBarComponent;
  @ViewChild(WelcomeBarComponent) welcomebar!: WelcomeBarComponent;
  @ViewChild(HeaderComponent) header!: HeaderComponent;
  clientName: any = '';
  constructor(private http: HttpClient, private route: ActivatedRoute) { }
  ngOnInit() {

    let client = this.route.snapshot.paramMap.get('client');
    if(client){
      this.clientName = client
      sessionStorage.setItem('currClient', client)
    }


    this.getFormConfiguration('en')
  }
  sideBarDisplay(value: string) {
    this.displaySideBar = JSON.parse(value);
    if (JSON.parse(value)) {
      this.width = "0"
    }
  }

  onSidebarToggle(isOpen: boolean) {
    this.sidebarOpen = isOpen;
  }

  language(event: any) {
    this.lang = event;
    this.overview.getFormConfiguration(event);
    this.sidebar.getFormConfiguration(event);
    this.welcomebar.getFormConfiguration(event);
  }

  getFormConfiguration(lang: any) {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = '/customer/formConfig';
    this.http.get(api.url + customerDataEndpoint, {
      headers: {

        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
        'Lang': lang,
      }
    }).subscribe((response: any) => {

      if (response.status == 200) {
        this.formConfig = response.data;

        this.form_typess = response.data.formTypes || [];
        console.log("Form types:", this.form_typess);
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: 'Info', text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: 'Info', text: error.error.error.message })
    });
  }

  getCustomerData() {
    const customerid = sessionStorage.getItem('customerId');
    const accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = '/customer/' + customerid + '/details';
    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.customer = response?.data;
        console.log('this.customer',this.customer)
        this.overview.getCustomerData(this.customer);
        this.customerSubject.next(this.customer);
      }
    })
  }

}
